import { cn } from '../../utils/cn';

export function QuickCreateHeroName({
  label,
  value,
  onChange,
  placeholder,
  className,
  autoFocus,
}) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-border bg-stone-50 px-[18px] py-[15px] dark:bg-muted/40',
        className,
      )}
    >
      <p className="text-[11px] font-semibold text-muted-foreground">{label}</p>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="mt-1.5 w-full border-0 bg-transparent p-0 font-display text-2xl font-semibold tracking-tight text-foreground outline-none placeholder:text-stone-300"
      />
    </div>
  );
}
